const AGW_APP_ID = 'cm04asygd041fmry9zmcyn5o5';
const ICON_URL = 'https://abstract-assets.abs.xyz/icons/light.png';
export { AGW_APP_ID, ICON_URL };
//# sourceMappingURL=constants.js.map